import React, {Component} from 'react';
import BundleTableItemVariants
  from './BundleTableItemVariants/BundleTableItemVariants.jsx';

export default class BundleTableItem extends Component {
  constructor (props) {
    super (props);

    this.state = {
      height: 0,
    };
    this.expandableRef = React.createRef ();

    this.handleClick = this.handleClick.bind (this);
    this.handleKeyPress = this.handleKeyPress.bind (this);
    this.handleClickClose = this.handleClickClose.bind (this);
  }

  handleClick () {
    const {activeItemId, item, handleActiveItemChange} = this.props,
      id = activeItemId === item.ProductNumber ? '' : item.ProductNumber;

    handleActiveItemChange (id);

    if (this.state.height === 0) {
      this.setState ({height: this.expandableRef.current.clientHeight});
    }
  }

  handleKeyPress (event) {
    if (event.charCode === 32 || event.charCode === 13) {
      this.handleClick ();
    }
  }

  handleClickClose () {
    this.props.handleActiveItemChange ('');
  }

  render () {
    const {open, item} = this.props;
    const currentHeight = open ? this.state.height : 0;

    return (
      <React.Fragment>
        <tr
          className="ordering-table__tr-expandable"
          onClick={this.handleClick}
          role="button"
          tabIndex="0"
          onKeyPress={this.handleKeyPress}
          aria-expanded={this.props.open}
          aria-controls={`accordion-${this.props.item.Id}`}
        >
          <td>{item.ProductNumber}</td>
          <td>{item.ProductName}</td>
        </tr>
        <tr className="ordering-table__tr-expanded">
          <td
            colSpan="2"
            className="ordering-table__td-variants-wrapper print-hidden"
          >
            <div
              className="ordering-table__accordion"
              style={{height: `${currentHeight}px`}}
              id={`accordion-${item.Id}`}
              aria-hidden={!open}
            >
              <div ref={this.expandableRef}>
                <BundleTableItemVariants
                  products={item.Items}
                  handleClickClose={this.handleClickClose}
                />
              </div>
            </div>
          </td>
        </tr>
      </React.Fragment>
    );
  }
}
